import type { FaireProductEntity } from "../../entity_types/product";

export const p_qkne22f6cu: FaireProductEntity = {
  token: "p_qkne22f6cu",
  type: "product",
  name: "Cedar Drip",
  brandToken: "b_qkjzzyp79p",
  brandName: "Nose Dive",
  imageUrl:
    "https://cdn.faire.com/fastly/1809eb0c6e5d951a9af952041f691e371a748f00c479cce6687550a4aa30f38f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1bbad741511ddb652a62839c3f500e24be48e54f9d92c1b43c3505b0d15ac5a3.png",
    "https://cdn.faire.com/fastly/c7c9f8e3403367c879c16db3143bcff8cee85affa68b131265d08658192cad3f.jpeg",
    "https://cdn.faire.com/fastly/1f6a795c719c364c7802b26cad16292c8ac19271ec7bd1f4d2a06a4503c8a459.jpeg",
    "https://cdn.faire.com/fastly/b0909437abd4cfc1322fc61d3bcd30a333afecbd5ad6ec7651909590e3748a1b.png",
  ],
  priceDollars: 22,
  description:
    "Cedar Drip captures the heart of the holidays — winter woods softened by the glow of a crackling fire. It’s cozy and nostalgic with a modern edge: bright, woodsy, and just the right amount of festive. A scent made for gathering close and lingering a little longer.\n\n\nTop Notes: Saffron, Blue Spruce, Jasmine, Orange Blossom\n\nMiddle Notes: Amberwood, Plum, Clove, Fir Needle\n\nBase Notes: Oakmoss, Cypress, Red Currant\n\nFounder's Note: \"This scent is nostalgic to me on so many levels. It reminds me of home. It's warm, it's cozy and it's the holidays all wrapped into a scent. We took your traditional balsam and cedar candle and put our twist on it. I burn this at all times of the day during the holidays and so should you.\"\n",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:18.636Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
